export const CmsFreeTypeDecorator = {
  url() {
    return `signup-hubspot/cms-free`;
  },
  query() {
    return {};
  }
};